import React, { useEffect, useState } from 'react';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { translate } from '../../services/translate';
import { appAgentService } from '../../services/central-api/app-agent';
import { View } from 'react-native';
import MyAppText from '../MyAppText';
import { minutesToText } from '../../services/time-helpers';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

interface Props {
    value: number;
    setValue: (value: number, item: DropdownResource | undefined) => void;
    zIndex?: number;
    disabled?: boolean;
    labelFontSize?: number;
    label?: string;
    unitId: number;
}

export default function PauseReasonsDropdown({ value, setValue, zIndex, disabled, labelFontSize, label, unitId }: Props) {
    const { styles } = useStyles(styleSheet);

    const [items, setItems] = useState<{ label: string; value: number; }[]>([]);
    const [originalPauseReasons, setOriginalPauseReasons] = useState<PauseReason[]>([]);

    async function getPauseReasons() {
        try {
            const response = await appAgentService.getPauseReasons(unitId);
            setOriginalPauseReasons(response);
            setItems(response.map(pauseReason => ({
                label: pauseReason.name, value: pauseReason.id!
            })));
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        getPauseReasons();
    }, []);

    return (
        <View style={{ flexDirection: 'column', gap: 16 }}>
            <FilterDropdown
                label={label ?? translate('pauseReason')}
                items={items}
                multiple={false}
                setValue={(v) => {
                    const itemId = v(-1);
                    const item = items.find(i => i.value == itemId);
                    setValue(itemId, item ? {
                        id: item.value,
                        name: item.label
                    } : undefined);
                }}
                value={value}
                zIndex={zIndex}
                disabled={disabled}
                labelFontSize={labelFontSize}
            />
            {value != 0 && <View style={{ flexDirection: 'row' }}>
                <MyAppText>
                    {`${translate('pauseReasonPeriod')}: `}
                    <MyAppText style={styles.pauseReasonPeriod}>{minutesToText(originalPauseReasons.find(opr => opr.id == value)?.pauseMinutes ?? null)}</MyAppText>
                </MyAppText>
            </View>}
        </View>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    pauseReasonPeriod: {
        color: theme.colors.primaryButton.background,
        fontWeight: '600'
    }
}));
